import {
    MDBBreadcrumb,
    MDBBreadcrumbItem
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router';
import { getLocUsers } from '../../apiclients/streamsapi_bridge';
import Body from '../body/BodyPage';
import MainLinks from '../navlinks/MainLinks';
import Users from './Users';


function LocationsUsers() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [addUsers, setAddUsers] = useState(false);
    const [locInfo, setLocInfo] = useState(
        location?.state?.tab ? location?.state?.tab : location.state ? location.state : {}
    );
    const [userList, setuserList] = useState([]);
    console.log("location details ::::::: " + JSON.stringify(locInfo));

    async function fetchLocUsers() {
        try {
            console.log("[fetchExistingLocations] ");
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const locid = locInfo.location_id;
            let serverResponse = await getLocUsers(siteid, locid, "");
            if (!serverResponse.json) {
                const message = `An error has occured: ${serverResponse.statusText}`;
                return;
            }
            const rawData = await serverResponse.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("location users :::::: " + JSON.stringify(rawData));
            setuserList(rawData.locations ?? []);

        } catch (error) {
            console.log(`Error in getLocUsers ${error}`);
        }
    }
    useEffect(() => {
        if (locInfo.location_id) {
            fetchLocUsers();

        }

    }, [locInfo.location_id])
    return (
        <React.Fragment>
            <MainLinks active={3} />
            <Body
                tablinks={3}
                sublink={8}
                content={
                    <>
                        <section className="mb-3">
                            <div className="card card-height">
                                <div className="card-header px-0">
                                    <h5 className="mb-0">
                                        <MDBBreadcrumb>
                                            <MDBBreadcrumbItem>
                                                <a onClick={(e) => {
                                                    navigate("/userlanding", {
                                                        state: { tab: "suser", tab2: "suser" },
                                                    });
                                                }}>
                                                    <strong>{t("users")}</strong>
                                                </a>
                                            </MDBBreadcrumbItem>
                                            <MDBBreadcrumbItem active>
                                                <a onClick={(e) => {
                                                    navigate("/userlanding", {
                                                        state: { tab: "suser", tab2: "sloc" },
                                                    });
                                                }}>
                                                    <strong>{t("locations")}</strong>
                                                </a>
                                            </MDBBreadcrumbItem>
                                            <MDBBreadcrumbItem>
                                                <a href="">
                                                    <strong>{locInfo.location_name} </strong>
                                                </a>
                                            </MDBBreadcrumbItem>
                                        </MDBBreadcrumb>
                                    </h5>
                                </div>
                                <div className="card-body usersTab_btns px-0">
                                    <div className="pb-2 mb-2">
                                        <h5 className="fw-600 mt-2 ">
                                            {locInfo.location_name}
                                        </h5>
                                        <p className="mt-2 text-secondary">
                                            {locInfo.address}
                                        </p>
                                        <h6 className="mt-2">
                                        </h6>
                                    </div>
                                    <Users addUsers={addUsers} userList={userList} locUsers={locInfo} />
                                </div>
                            </div>
                        </section>
                    </>
                }
            />
        </React.Fragment>
    )
}

export default LocationsUsers
